module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/personnel-details/Personnel-Relievings/personnel-relieving/personnel-relieving.component.css
// module id = ./src/app/pages/functions/personnel-details/Personnel-Relievings/personnel-relieving/personnel-relieving.component.css
// module chunks = main